import api from "../utils/api";
import * as url from "./urls";

export interface TacitsBalance {
  allocated: number;
  manual_credits: number;
  used: number;
  remaining: number;
  plan: string;
}

export interface CreditPackage {
  id: string;
  tacits: number;
  price_usd: number;
  label: string;
  popular: boolean;
}

export interface TacitsCreditTransaction {
  id: string;
  company_id: string;
  amount: number;
  type: string;
  reason: string;
  created_by: string;
  stripe_payment_id?: string;
  created_at: string;
}

export const getTacitsBalance = (): Promise<TacitsBalance> =>
  api.get<TacitsBalance>(url.GET_TACITS_BALANCE).then((r) => r.data);

export interface DailyTacitsEntry {
  date: string;
  tacits: number;
  cost: number;
}

export const getTacitsDailyForCompany = (
  companyId: string,
  startDate: string,
  endDate: string,
): Promise<DailyTacitsEntry[]> =>
  api
    .post<{
      data: Array<{
        date: string;
        companies: Record<string, { tacits: number; cost: number }>;
      }>;
    }>(url.GET_TACITS_DAILY, {
      company_ids: [companyId],
      start_date: startDate,
      end_date: endDate,
    })
    .then((res) =>
      (res.data?.data ?? []).map((point) => ({
        date: point.date,
        tacits: point.companies[companyId]?.tacits ?? 0,
        cost: point.companies[companyId]?.cost ?? 0,
      })),
    );

export const getCreditPackages = (): Promise<CreditPackage[]> =>
  api
    .get<{ data: CreditPackage[] }>(url.GET_CREDIT_PACKAGES)
    .then((r) => r.data?.data ?? []);

export const purchaseTacits = (
  packageId: string,
  successUrl: string,
  cancelUrl: string,
): Promise<{ checkout_url: string }> =>
  api
    .post<{ checkout_url: string }>(url.POST_PURCHASE_TACITS, {
      package_id: packageId,
      success_url: successUrl,
      cancel_url: cancelUrl,
    })
    .then((r) => r.data);

export const getCreditHistory = (): Promise<TacitsCreditTransaction[]> =>
  api
    .get<{ data: TacitsCreditTransaction[] }>(url.GET_CREDIT_HISTORY)
    .then((r) => r.data?.data ?? []);
